module.exports = __webpack_public_path__ + "img/broadband.d3a1872.webp";